import m from "mithril";
import { store } from "../models/store.js";
import { PhotoInput } from "./PhotoInput.js";
import { ImageViewer } from "./ImageViewer.js";
import { ItemList } from "./ItemList.js";
import { Totals } from "./Totals.js";

// Root component. Lays the flow out top to bottom: get a photo, scan it, tick
// items, read the total. Everything below the photo appears as the scan
// progresses.

const INTRO_BLURB =
  "Take a photo of the receipt — or share one to this app — and it’ll read the items for you.";

const isBusy = () => store.phase === "ocr" || store.phase === "parsing";

function renderStatusBar(): m.Vnode | null {
  if (!store.status) return null;
  return m("div.status", { class: isBusy() ? "busy" : "" }, [
    isBusy() ? m("span.spinner") : null,
    m("span", store.status),
  ]);
}

function renderRawPanel(): m.Vnode | null {
  if (!store.ocrText) return null;
  return m("details.raw", [
    m("summary", "Raw scanned text"),
    m("pre", store.ocrText),
  ]);
}

export const App: m.Component = {
  view() {
    const hasImage = !!store.imageUrl;
    return m("main.app", [
      m("header.masthead", [
        m("h1", "tally"),
        m(
          "p.tagline",
          "Scan a receipt, tick what’s yours, split the bill. All on your device.",
        ),
      ]),

      m("section.intake", { class: hasImage ? "compact" : "" }, [
        m(PhotoInput),
        !hasImage ? m("p.blurb", INTRO_BLURB) : null,
      ]),

      renderStatusBar(),
      hasImage ? m(ImageViewer) : null,
      m(ItemList),
      m(Totals),
      renderRawPanel(),

      m("footer.foot", [
        m("span", "Runs entirely in your browser · no upload, no account."),
      ]),
    ]);
  },
};
